'use client'
import { useMerchant } from "@/src/context/merchant/merchant-context";
import { useEffect, useState } from "react";
import { CustomInstallPopup } from "../popup-mobile/popup-mobile";

export default function InstallMobileApp() {
  const { merchantSummary } = useMerchant()
  const [showPopup, setShowPopup] = useState(false)
  const [closePopUp, setClosePopUp] = useState(false)

  //aguardando dado dinamico
  const hasApp = true

  useEffect(() => {
    const subdomain = window.location.hostname.split('.')[0]

    if (typeof window !== "undefined" && hasApp && subdomain === 'vipbar') {
      const userAgent = window.navigator.userAgent.toLowerCase()

      const isAndroid = /android/.test(userAgent)
      const isIOS = /iphone|ipad|ipod/.test(userAgent)

      if (isAndroid || isIOS) {
        setShowPopup(true)
      }
    }
  }, [])

  const handleInstallClick = () => {
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent.toLowerCase() : ""

    const isAndroid = /android/.test(userAgent)
    const isIOS = /iphone|ipad|ipod/.test(userAgent)

    if (isAndroid) {
      //aguardando dado dinamico
      window.location.href = "https://play.google.com/store/apps/details?id=com.Consumer.GilLanches&pcampaignid=web_share"
    } else if (isIOS) {
      //aguardando dado dinamico
      window.location.href = "https://apps.apple.com/br/app/gil-lanches/id1437530385"
    } else {
      alert("Dispositivo não suportado para instalação.")
    }
  }

  const handleClosePopup = () => {
    setClosePopUp(true)
    setTimeout(() => {
      setClosePopUp(false)
      setShowPopup(false)
    }, 300);
  }

  if (!showPopup) return null


  return (
    <CustomInstallPopup
      isOpen={showPopup}
      logoUrl={merchantSummary?.logoUrl || ""}
      merchantName={merchantSummary?.name || ""}
      mainText="Já conhece o nosso aplicativo?"
      subText={
        <>
          Baixe o <strong>{merchantSummary?.name}</strong> no seu celular e tenha acesso ao cardápio completo, além de <strong>descontos exclusivos</strong> que só quem tem o app pode aproveitar!
        </>
      }
      onClose={handleClosePopup}
      onInstall={handleInstallClick}
      installLabel="Instalar"
    />
  )
}